var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 64.5C128 29.154 99.346 0.5 64 0.5C28.654 0.5 0 29.154 0 64.5C0 96.444 23.404 122.922 54 127.723V83H37.75V64.5H54V50.4C54 34.36 63.555 25.5 78.174 25.5C85.176 25.5 92.5 26.75 92.5 26.75V42.5H84.43C76.4795 42.5 74 47.4335 74 52.495V64.5H91.75L88.9125 83H74V127.723C104.596 122.922 128 96.4445 128 64.5Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9125 83L91.75 64.5H74V52.495C74 47.433 76.4795 42.5 84.43 42.5H92.5V26.75C92.5 26.75 85.176 25.5 78.1735 25.5C63.555 25.5 54 34.36 54 50.4V64.5H37.75V83H54V127.723C57.3081 128.241 60.6515 128.501 64 128.5C67.3485 128.501 70.6919 128.241 74 127.723V83H88.9125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0a2967f143f97ca38d05f1f0202aee95.svg";
export { ForwardRef as ReactComponent };